import BadgeCollection from '@/components/gamification/BadgeCollection';

export default function BadgesPage() {
  return (
    <div className="min-h-full bg-gray-50">
      <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
        <div className="px-4 py-6 sm:px-0">
          <BadgeCollection />
        </div>
      </div>
    </div>
  );
}

